import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';
import useUpdateEffect from '../../hooks/useUpdateEffect';
import { allGroupsState } from '../../storage/groups';
import {
  reportFilterGroupState,
  reportIntervalState,
  reportIsManualIntervalState,
  reportSearchTypeState,
  reportSelectedAssetIdsState,
  reportViewState,
  updateReportState,
} from '../../storage/reports';
import useReportFilters from './hooks/useReportFilters';

function ReportFiltersProvider() {
  const filterGroup = useRecoilValue(reportFilterGroupState);
  const groups = useRecoilValue(allGroupsState);
  const interval = useRecoilValue(reportIntervalState);
  const isManualInterval = useRecoilValue(reportIsManualIntervalState);
  const reportView = useRecoilValue(reportViewState);
  const resetSelectedAssetIds = useResetRecoilState(reportSelectedAssetIdsState);
  const searchType = useRecoilValue(reportSearchTypeState);
  const setSelectedAssetIds = useSetRecoilState(reportSelectedAssetIdsState);
  const updateReport = useRecoilValue(updateReportState);
  const { setDates, resetFilters } = useReportFilters();

  useEffect(() => {
    return () => {
      resetFilters();
    };
  }, []);

  useUpdateEffect(() => {
    setDates();
  }, [isManualInterval, interval, updateReport]);

  useEffect(() => {
    if (filterGroup && groups) {
      const selectedGroup = groups.find((group) => group._id === filterGroup);
      if (selectedGroup) {
        setSelectedAssetIds(selectedGroup.assignedAssets);
        return;
      }
    }
    resetSelectedAssetIds();
  }, [reportView, filterGroup, groups]);

  useEffect(() => {
    resetFilters(true);
  }, [searchType]);

  return <Outlet />;
}

export default ReportFiltersProvider;
